const state = {
  userStatus: [
    { id: 0, name: "Tất cả" },
    { id: 2, name: "Đang hoạt động" },
    { id: 3, name: "Ngừng hoạt động" },
  ],
  roleUser: [
    { id: 0, name: "Tất cả" },
    { id: 1, name: "Admin" },
    { id: 2, name: "Người dùng" },
  ],
  roleSelect: [
    { id: 1, RoleName: "Admin" },
    { id: 2, RoleName: "Người dùng" },
  ],
  disabledRole: false,
  merchants: null,
  RoleLocal: null,

  //Các biến phục vụ cho thu hộ doanh nghiệp
  cboCustomers: [],
  currentPeriod: null,
};

export default state;
